module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://shadow.zhaogangimg.com/assets/zgkaihu/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 155);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/asyncToGenerator");

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.object.to-string");

/***/ }),

/***/ 155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "core-js/modules/es.function.name"
var es_function_name_ = __webpack_require__(3);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/cft-scan-dialog/src/main.vue?vue&type=template&id=76d1273b&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.dialogTitle,
        visible: _vm.visible,
        width: "440px",
        "custom-class": "zg-kh-cft-scan-dialog",
        "before-close": _vm.close,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": _vm.appendToBody
      }
    },
    [
      _vm.tip
        ? _c("div", { staticClass: "zg-kh-cft-scan-dialog-head" }, [
            _c("img", {
              attrs: { src: __webpack_require__(43), alt: "" }
            }),
            _c("div", { staticClass: "zg-kh-cft-scan-dialog-tip" }, [
              _vm._v(_vm._s(_vm.tip))
            ])
          ])
        : _vm._e(),
      _c("div", { staticClass: "zg-kh-cft-scan-dialog-qrcode-wrapper" }, [
        _c("div", { attrs: { id: "tenpay-qrcode-wrapper" } })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/cft-scan-dialog/src/main.vue?vue&type=template&id=76d1273b&

// EXTERNAL MODULE: external "core-js/modules/es.object.to-string"
var es_object_to_string_ = __webpack_require__(14);

// EXTERNAL MODULE: external "core-js/modules/es.promise"
var es_promise_ = __webpack_require__(67);

// EXTERNAL MODULE: external "regenerator-runtime/runtime"
var runtime_ = __webpack_require__(7);

// EXTERNAL MODULE: external "@babel/runtime/helpers/asyncToGenerator"
var asyncToGenerator_ = __webpack_require__(1);
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cft-scan-dialog/src/main.vue?vue&type=script&lang=js&




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var mainvue_type_script_lang_js_ = ({
  name: 'ZgKhCftScanDialog',
  props: {
    dialogTitle: {
      type: String,
      default: '提示'
    },
    tip: {
      type: String,
      default: ''
    },
    visible: Boolean,

    /** 二维码信息对象*/
    qrCodeInfo: Object,
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      Entpay: false
    };
  },
  computed: {},
  watch: {
    'qrCodeInfo.qrCode': {
      handler: function handler(newval, oldval) {
        if (this.visible && newval && newval !== oldval) {
          this.$nextTick(function () {
            this.qrCodeRender();
          });
        }
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var Entpay;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.insertScript();

            case 2:
              Entpay = _context.sent;
              Entpay && (_this.Entpay = Entpay);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    qrCodeRender: function qrCodeRender() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$Promise, success, _yield$Promise$msg, msg, _yield$Promise$errcod, errcode;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return new Promise(function (resolve, reject) {
                  _this2.Entpay.initQR({
                    qrcodeUrl: _this2.qrCodeInfo.qrCode,
                    // 必填，二维码
                    qrcodeSkey: _this2.qrCodeInfo.qrCodeSk,
                    // 必填，二维码凭证
                    platformId: _this2.qrCodeInfo.platformId,
                    // 必填，平台商户的平台帐号
                    element: 'tenpay-qrcode-wrapper',
                    // 必填，需要绘制二维码的区域元素id
                    success: function success() {
                      // 设置成功回调
                      resolve({
                        success: true,
                        msg: '二维码生成成功'
                      });
                    },
                    fail: function fail(res) {
                      // 调用失败返回，⻅下文错误码含义
                      resolve({
                        success: false,
                        msg: res.errmsg,
                        errcode: res.errcode
                      });
                    }
                  });
                });

              case 3:
                _yield$Promise = _context2.sent;
                success = _yield$Promise.success;
                _yield$Promise$msg = _yield$Promise.msg;
                msg = _yield$Promise$msg === void 0 ? '' : _yield$Promise$msg;
                _yield$Promise$errcod = _yield$Promise.errcode;
                errcode = _yield$Promise$errcod === void 0 ? '' : _yield$Promise$errcod;

                if (!success) {
                  _this2.$emit('cftScanTenpayInitFail', {
                    msg: msg,
                    errcode: errcode
                  });
                }

                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](0);
                console.log('-----qrCodeRenderErr-----', _context2.t0);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 12]]);
      }))();
    },
    close: function close() {
      this.$emit('update:visible', false);
      this.$emit('closeHandler');
    },
    insertScript: function insertScript() {
      var src = 'https://mqq-imgcache.gtimg.cn/qifang/entpay/js-sdk-0.0.1.js';
      return new Promise(function (resolve, reject) {
        if (typeof window.entpay === 'undefined') {
          var _head = document.getElementsByTagName('body')[0];

          var _script = document.createElement('script');

          _script.type = 'text/javascript';
          _script.src = src;
          _script.defer = true;

          _head.appendChild(_script);

          _script.onload = function () {
            resolve(window.entpay);
          };

          _script.onerror = function () {
            resolve(false);
          };
        } else {
          resolve(window.entpay);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./packages/cft-scan-dialog/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_mainvue_type_script_lang_js_ = (mainvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/cft-scan-dialog/src/main.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_mainvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/cft-scan-dialog/src/main.vue"
/* harmony default export */ var main = (component.exports);
// CONCATENATED MODULE: ./packages/cft-scan-dialog/index.js


/* istanbul ignore next */

main.install = function (Vue) {
  Vue.component(main.name, main);
};

/* harmony default export */ var cft_scan_dialog = __webpack_exports__["default"] = (main);

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.function.name");

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAclBMVEVHcEzx8fHw8PD////z8/Pw8PDx8fH////x8fHx8fH+/v709PT4+Pj9/f319fXJycn29vacnJzd3d3x8fGxsbG9vb3t7e36+vqzs7Otra3k5OTh4eGbm5uioqLm5uaZmZmoqKijo6OdnZ3X19f7+/vv7++pfeeFAAAACnRSTlMAj73/K/PVBpT9tFB1bgAAAIVJREFUGNNlT0kChCAMK7IIAupszj7O5v+/KKRy0R5KG5o0JUqhhNHaCEUctXUhShmDszX6yjcS0fgqI9aj6aaUvU18h//++8uwUyQCxtsWTxBkYi7uzyOAaEijOOxOLKwX4DbuC8CU7nEuFBa9XoYiyms/75dc1rKx/o+BbGxrfXPc6vwZdR0GjIYWUM4AAAAASUVORK5CYII="

/***/ }),

/***/ 67:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.promise");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("regenerator-runtime/runtime");

/***/ })

/******/ });